import z from "zod";

export type OrderBookOmitTimestamp = {
  asks: [number, number][];
  bids: [number, number][];
};

export const OrderBookDepthLevelSchema = z.object({
  up: z.number(), // in fiat
  down: z.number(), // in fiat
});
export type OrderBookDepthLevel = z.infer<typeof OrderBookDepthLevelSchema>;

export const OrderBookDepthsSchema = z.record(z.string(), OrderBookDepthLevelSchema);
export type OrderBookDepths = z.infer<typeof OrderBookDepthsSchema>;

export const OrderBookMetricsSchema = z
  .object({
    midPrice: z.number(),
    spread: z.number(),
    depths: OrderBookDepthsSchema,
  })
  .nullable();
export type OrderBookMetrics = z.infer<typeof OrderBookMetricsSchema>;

export const OrderBookDepthResponseSchema = OrderBookDepthLevelSchema.nullable();
export type OrderBookDepthResponse = z.infer<typeof OrderBookDepthResponseSchema>;

export const OrderBookDeepthSchema = z.object({
  up: z.number(),
  down: z.number(),
});
export type OrderBookDeepthDto = z.infer<typeof OrderBookDeepthSchema>;

export const OrderBookDeepthResponseSchema = OrderBookDeepthSchema.nullable();
export type OrderBookDeepthResponse = z.infer<typeof OrderBookDeepthResponseSchema>;
